import { LoginCallback } from '@okta/okta-react'
import React from 'react'
import { Route, Switch, useHistory } from 'react-router-dom'
import { useAuth, usePermissions } from '../../hooks'
import { RoutesEnum } from '../../types/RoutesEnum'
import { ApexLogin } from '../ApexLogin'
import AppLayout from '../AppLayout'
import { InitiateTransferPage } from '../../components/InitiateTransferPage'
import { TransferDetailsPage } from '../TransferDetailsPage'
import { AccountSearchPage } from '../../components/AccountSearch'
import { ParticipantIdsPage } from '../ParticipantIdsPage'
import TransferSearchPage from '../../components/TransferSearch/TransferSearchPage'
import { PermissionsEnum } from '../../constants'
import PermissionRoute from '../../components/PermissionRoute/PermissionRoute'
import { setRumSessionUser, clearRumUser } from '../../utils/datadog'
import { useVerifySession, fetchLogout } from 'ui-classic-common-library'

export const App = () => {
  const history = useHistory()
  const { showAppContent } = useAuth()
  const { hasPermission } = usePermissions()

  const canRead = hasPermission(PermissionsEnum.AlpsRead)
  const { isSessionLoading, hasSession } = useVerifySession()
  setRumSessionUser()
  const canModifyAndSubmit =
    canRead &&
    hasPermission(PermissionsEnum.AlpsModify) &&
    hasPermission(PermissionsEnum.AlpsSubmit)

  const transferReviewPermissions = [PermissionsEnum.AlpsRead]
  const initiateTransferPermissions = [
    PermissionsEnum.AlpsRead,
    PermissionsEnum.AlpsModify,
    PermissionsEnum.AlpsSubmit,
  ]
  return (
    <AppLayout
      includeHeader={
        history.location.pathname !== `/${RoutesEnum.ParticipantIds}`
      }
      includeSubNavigation={canModifyAndSubmit}
      fetchLogout={() => {
        fetchLogout().then(() => {
          window.location.href = `/${RoutesEnum.Root}`
          clearRumUser()
        })
      }}
      showAppContent={hasSession}
    >
      {hasSession && showAppContent ? (
        <>
          <Route path="/" component={LoginCallback} />
          <Switch>
            <PermissionRoute
              path={`/${RoutesEnum.TransferReview}/:acatControlNumber`}
              component={TransferDetailsPage}
              requiredPermissions={transferReviewPermissions}
            />
            <PermissionRoute
              path={`/${RoutesEnum.TransferReview}`}
              component={TransferSearchPage}
              requiredPermissions={transferReviewPermissions}
            />
            <PermissionRoute
              path={`/${RoutesEnum.InitiateTransfer}/:accountNumber`}
              component={InitiateTransferPage}
              requiredPermissions={initiateTransferPermissions}
            />
            <PermissionRoute
              path={`/${RoutesEnum.InitiateTransfer}`}
              component={AccountSearchPage}
              requiredPermissions={initiateTransferPermissions}
            />
            <PermissionRoute
              path={`/${RoutesEnum.ParticipantIds}`}
              exact
              component={ParticipantIdsPage}
              requiredPermissions={initiateTransferPermissions}
            />
            <PermissionRoute
              path={`/`}
              component={TransferSearchPage}
              requiredPermissions={transferReviewPermissions}
            />
          </Switch>
        </>
      ) : (
        <ApexLogin isSessionLoading={isSessionLoading} />
      )}
    </AppLayout>
  )
}
